// extracted by mini-css-extract-plugin
export default {"root":"zLtZu","item":"BkZBn","error":"ct8KS","title":"xl8Bz","remove":"tCcRU"};